import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { loadConfig } from 'packages/lib/config';
import { ENV } from 'packages/env';
import { useUserProfile } from 'packages/lib/utils/hooks/use-auth-data';

export const useTracking = (
  trackingId: string | undefined = loadConfig().GAID
): void => {
  const { pathname } = useLocation();
  const { userProfile } = useUserProfile();

  useEffect(() => {
    if (!window.gtag) return;
    if (!trackingId) {
      console.log(
        'Tracking not enabled, as `trackingId` was not given and there is no `GA_MEASUREMENT_ID`.'
      );
      return;
    }

    if (ENV === 'production') {
      window.gtag('set', 'page_path', pathname);
      window.gtag('event', 'page_view');
    }

    if (userProfile) {
      window.gtag('config', loadConfig().GAID, {
        user_id: userProfile.email,
      });
    }
  }, [pathname, trackingId, userProfile]);
};
